import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const LineReveal = ({ lines, as: Tag = "h1", className = "", lineClassName = "", delay = 0.25 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);
